class Interview {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var interviewSwiper = new Swiper(".js-swiper-interview", {
      slidesPerView: 1.4,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      speed: 1000, 
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 30,
        }
      },
      pagination: {
        el: ".js-swiper-interview-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-swiper-interview-next",
        prevEl: ".js-swiper-interview-prev",
      },
    });
  }
}
